import { Component, OnInit, Inject } from '@angular/core';

import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from '../models/types';

@Component({
    selector: 'app-side-effect-cancel-permit',
    templateUrl: './side-effect-cancel-permit.component.html',
    styleUrls: ['./side-effect-cancel-permit.component.scss'],
    standalone: false
})
export class SideEffectCancelPermitComponent implements OnInit {

  public _seConfiguration: any;

  set seConfiguration(value: any) {
    this._seConfiguration = value || {};
    this._seConfiguration.contextTargetForPermitId = this._seConfiguration.contextTargetForPermitId || "$.permit.value.0.id";
  }

  get seConfiguration(): any {
    return this._seConfiguration;
  }

  constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
    this.seConfiguration = data.configuration;
  }

  ngOnInit() {
  }

}
